import React, { useEffect, useState } from "react";
import Topbar from "../../components/Recruiter/Topbar/Topbar";
import { AuthContext } from "../../context/AuthContext";
import { useContext } from "react";
import CryptoJS from "crypto-js";
import ButtonSolid from "../../components/elements/Button/ButtonSolid";
import ButtonHallow from "../../components/elements/Button/ButtonHallow";
import Textinput from "../../components/elements/TextInput/TextInput";
import Swal from "sweetalert2";
import ClipLoader from "react-spinners/ClipLoader";

const AdminPricing = () => {
    const { token } = useContext(AuthContext);
    const [planDetails, setPlanDetails] = useState([]);
    const [selectedPlan, setSelectedPlan] = useState(null);
    const [isEditing, setIsEditing] = useState(false);
    const [isAdding, setIsAdding] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    // const [newPlan, setNewPlan] = useState({
    //     name: "",
    //     storage_space: "",
    //     no_of_recruiters: "",
    //     no_of_jobs: "",
    //     no_of_resumes: "",
    //     no_of_emails: "",
    //     job_ai_usage: "",
    //     duration: { months: "" }
    // });
    const [newPlan, setNewPlan] = useState({
        name: "",
        storage_space: "",
        no_of_recruiters: 0,
        no_of_jobs: 0,
        no_of_resumes: 0,
        no_of_emails: 0,
        job_ai_usage: 0,
        email_ai_usage: 0,
        sms_count: 0,
        whats_app_count: 0,
        email_count: 0,
        no_of_cand: 0,
        no_of_jds: 0,
        overage: false,
        duration: { months: 1 },  // Default to 1 month
        token: 0
    });
    
    const handleAddPlan = () => {
        setIsAdding(true);
    };

    // const handleInputChange = (e) => {
    //     const { name, value } = e.target;
    //     if (name === "months") {
    //         setNewPlan({ ...newPlan, duration: { months: value } });
    //     } else {
    //         setNewPlan({ ...newPlan, [name]: value });
    //     }
    // };
    const handleInputChange = (e) => {
        const { name, value } = e.target;
    
        if (name === "months") {
            setNewPlan((prevPlan) => ({
                ...prevPlan,
                duration: { months: value }
            }));
        } else if (name === "overage") {
            setNewPlan((prevPlan) => ({
                ...prevPlan,
                [name]: value === "true"
            }));
        } else if (!isNaN(value) && value !== "") {
            setNewPlan((prevPlan) => ({
                ...prevPlan,
                [name]: Number(value)
            }));
        } else {
            setNewPlan((prevPlan) => ({
                ...prevPlan,
                [name]: value
            }));
        }
    };
    

    const handleSubmit = async () => {
        const requiredFields = [
            "name", "no_of_resumes", "no_of_recruiters", "no_of_jobs",
            "no_of_cand", "no_of_emails", "job_ai_usage", "email_ai_usage",
            "sms_count", "whats_app_count", "email_count", "storage_space",
            "no_of_jds", "token", "duration"
        ];
    
        const missingFields = requiredFields
        .filter(field => !newPlan[field] && newPlan[field] !== 0)
        .map(field => field.replace(/_/g, " ").replace(/\b\w/g, char => char.toUpperCase()));
    
        if (missingFields.length > 0) {
            await Swal.fire({
                title: "Missing Fields!",
                text: `Please fill the required fields: ${missingFields.join(", ")}`,
                icon: "error",
                confirmButtonColor: "#3085d6",
            });
            return;
        }
        const confirmResult = await Swal.fire({
            title: "Are you sure?",
            text: "Do you want to add this plan?",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: "Yes, add it!",
            cancelButtonText: "Cancel",
        });
    
        if (!confirmResult.isConfirmed) {
            return;
        }
        try {
            setIsLoading(true);
            const encryptedMetadataAll = localStorage.getItem("metadata");
            const decryptedMetadataAll = JSON.parse(
                CryptoJS.AES.decrypt(encryptedMetadataAll, secretKey).toString(CryptoJS.enc.Utf8)
            );
            const uid = decryptedMetadataAll.uid;
    
            const payload = {
                name: newPlan.name || "",
                no_of_resumes: Number(newPlan.no_of_resumes) || 0,
                no_of_recruiters: Number(newPlan.no_of_recruiters) || 0,
                no_of_jobs: Number(newPlan.no_of_jobs) || 0,
                no_of_cand: Number(newPlan.no_of_cand) || 0,
                no_of_emails: Number(newPlan.no_of_emails) || 0,
                job_ai_usage: Number(newPlan.job_ai_usage) || 0,
                email_ai_usage: Number(newPlan.email_ai_usage) || 0,
                sms_count: Number(newPlan.sms_count) || 0,
                whats_app_count: Number(newPlan.whats_app_count) || 0,
                email_count: Number(newPlan.email_count) || 0,
                overage: newPlan.overage || false,
                duration: newPlan.duration?.months ? `${newPlan.duration.months} mon` : "1 mon",
                storage_space: `${newPlan.storage_space}GB` || "",
                no_of_jds: Number(newPlan.no_of_jds) || 0,
                token: Number(newPlan.token) || 0,
                uid
            };
    
            const encryptedData = CryptoJS.AES.encrypt(
                JSON.stringify(payload),
                secretKey
            ).toString();
    
            const response = await fetch(`${serverURL}/subscription/insertPlan`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    token: token,
                },
                body: JSON.stringify({ data: encryptedData }),
            });
    
            const data = await response.json();
            const decryptedData = JSON.parse(
                CryptoJS.AES.decrypt(data.data, secretKey).toString(CryptoJS.enc.Utf8)
            );
    
            if (decryptedData.success) {
                console.log("Plan Added Successfully:", decryptedData);
                setIsLoading(false);
                setIsAdding(false);
            } else {
                console.error("Failed to Add Plan:", decryptedData);
            }
        } catch (err) {
            console.error("Error:", err);
        } finally{
            setIsAdding(false);
            setTimeout(() => {
                window.location.reload();
            }, 500); 
        }
    };
    
    // const handleDeletePlan = (plan) => {
    //     Swal.fire({
    //         title: "Are you sure?",
    //         text: "You won't be able to revert this!",
    //         icon: "warning",
    //         showCancelButton: true,
    //         confirmButtonColor: "#059669",
    //         cancelButtonColor: "red",
    //         confirmButtonText: "Yes, delete it!"
    //     }).then((result) => {
    //         if (result.isConfirmed) {
    //             console.log(plan,"delete plan");
    //         }
    //     });
    // };

    const serverURL = process.env.REACT_APP_SERVER_URL;
    const secretKey = process.env.REACT_APP_SECRETKEY;

    const fetchPlanDetails = async () => {
        try {
            const encryptedMetadataAll = localStorage.getItem('metadata');
            const decryptedMetadataAll = JSON.parse(CryptoJS.AES.decrypt(encryptedMetadataAll, secretKey).toString(CryptoJS.enc.Utf8));
            const uid = decryptedMetadataAll.uid;
            const encryptedData = CryptoJS.AES.encrypt(JSON.stringify({ uid }), secretKey).toString();
            const response = await fetch(`${serverURL}/subscription/getPlans`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    token: token,
                },
                body: JSON.stringify({ data: encryptedData}),
            });

            const data = await response.json();
            const decryptedData = JSON.parse(
                CryptoJS.AES.decrypt(data.data, secretKey).toString(CryptoJS.enc.Utf8)
            );

            if (decryptedData) {
                setPlanDetails(decryptedData);
                console.log("Plan Details:", decryptedData);
            }
        } catch (err) {
            console.log("Error:", err);
        }
    };

    useEffect(() => {
        fetchPlanDetails();
    }, []);

    const handleEditClick = (plan) => {
        setSelectedPlan(plan);
        setIsEditing(true);
    };

    const handleSave = async () => {
        const requiredFields = [
            "name", "no_of_resumes", "no_of_recruiters", "no_of_jobs",
            "no_of_cand", "no_of_emails", "job_ai_usage", "email_ai_usage",
            "sms_count", "whats_app_count", "email_count", "storage_space",
            "no_of_jds", "token", "duration"
        ];
    
        const missingFields = requiredFields
            .filter(field => !selectedPlan[field] && selectedPlan[field] !== 0)
            .map(field => field.replace(/_/g, " ").replace(/\b\w/g, char => char.toUpperCase()));
    
        if (missingFields.length > 0) {
            await Swal.fire({
                title: "Missing Fields!",
                text: `Please fill the required fields: ${missingFields.join(", ")}`,
                icon: "error",
                confirmButtonColor: "#3085d6",
            });
            return;
        }
    
        const confirmResult = await Swal.fire({
            title: "Are you sure?",
            text: "Do you want to update this plan?",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: "Yes, update it!",
            cancelButtonText: "Cancel",
        });
    
        if (!confirmResult.isConfirmed) {
            return;
        }
    
        try {
            setIsLoading(true);
            const encryptedMetadataAll = localStorage.getItem("metadata");
            const decryptedMetadataAll = JSON.parse(
                CryptoJS.AES.decrypt(encryptedMetadataAll, secretKey).toString(CryptoJS.enc.Utf8)
            );
            const uid = decryptedMetadataAll.uid;
    
            const payload = {
                ...selectedPlan,
                duration: `${selectedPlan.duration.months} mon`,
                storage_space: `${selectedPlan.storage_space}GB`,
                uid
            };
    
            const encryptedData = CryptoJS.AES.encrypt(
                JSON.stringify(payload),
                secretKey
            ).toString();
    
            const response = await fetch(`${serverURL}/subscription/updatePlans`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    token: token,
                },
                body: JSON.stringify({ data: encryptedData }),
            });
    
            const data = await response.json();
            const decryptedData = JSON.parse(
                CryptoJS.AES.decrypt(data.data, secretKey).toString(CryptoJS.enc.Utf8)
            );
    
            if (decryptedData.success) {
                console.log("Plan Updated Successfully:", decryptedData);
                setIsLoading(false);
                setIsEditing(false);
            } else {
                console.error("Failed to Update Plan:", decryptedData);
            }
        } catch (err) {
            console.error("Error:", err);
        } finally {
            setTimeout(() => {
                window.location.reload();
            }, 500);
        }
    };
    

    return (
        <div className="min-h-screen radial-gradient-bg">
            {isLoading && (
                <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
                    <div className="flex flex-col items-center">
                    <ClipLoader color="#3498db" loading={isLoading} size={50} />
                    <span className="text-white mt-4">Loading...</span>
                    </div>
                </div>
            )}
            <Topbar />
            <div className="max-w-6xl mt-6 mx-auto">
            {isAdding && (
                <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-[9]">
                    <div className="bg-white p-8 rounded-2xl shadow-xl w-[600px] max-h-[90vh] flex flex-col">
                        <h2 className="text-2xl font-bold text-gray-900 mb-6">Add New Plan</h2>

                        {/* Scrollable Content */}
                        <div className="flex-1 overflow-y-auto max-h-[calc(90vh-72px)] mb-4">
                            <div className="grid grid-cols-2 gap-4">
                            {Object.keys(newPlan).map((key) => (
                                    key === "overage" ? (
                                        <div key={key}>
                                            <label className="block text-sm font-medium text-gray-700 capitalize">
                                                {key.replace(/_/g, " ")}
                                            </label>
                                            <select
                                                name={key}
                                                value={newPlan?.[key]}
                                                onChange={handleInputChange}
                                                className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg w-full p-3 mt-4"
                                            >
                                                <option value="true">Enable</option>
                                                <option value="false">Disable</option>
                                            </select>
                                        </div>
                                    ) : key === "duration" ? (
                                        <div key={key}>
                                            <label className="block text-sm font-medium text-gray-700">Duration (Months)</label>
                                            <Textinput
                                                type="number"
                                                name="months"
                                                placeholder="Enter duration in months"
                                                value={newPlan?.duration.months}
                                                onChange={handleInputChange}
                                                className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg w-full p-3 mt-1"
                                            />
                                        </div>
                                    ) : (
                                        <div key={key}>
                                            <label className="block text-sm font-medium text-gray-700 capitalize">
                                                {key.replace(/_/g, " ")}
                                            </label>
                                            <Textinput
                                                type={typeof newPlan?.[key] === "number" ? "number" : "text"}
                                                name={key}
                                                placeholder={key.replace(/_/g, " ")}
                                                value={newPlan?.[key]}
                                                onChange={handleInputChange}
                                                className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg w-full p-3 mt-1"
                                            />
                                        </div>
                                    )
                                ))}
                            </div>
                        </div>

                        <div className="pt-4 border-t border-gray-200 flex justify-between">
                            <ButtonSolid onClick={handleSubmit} className="px-6 py-2 rounded-lg w-1/2 mr-2" content="Add plan" />
                            <ButtonHallow onClick={() => setIsAdding(false)} className="px-6 py-2 rounded-lg w-1/2 ml-2" content="Cancel" />
                        </div>
                    </div>
                </div>           
            )}
                <div className="flex w-full" style={{alignItems: 'center'}}>
                <h1 className="text-3xl font-semibold text-gray-800 mb-6">Plans</h1>
                <ButtonSolid onClick={handleAddPlan} content="Add Plan" className="ml-auto w-auto mb-4" />
                </div>
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
                    {planDetails.map((plan) => (
                        <div key={plan?.plans_id} className="bg-white p-6 rounded-2xl shadow-lg">
                            <h2 className="text-xl font-bold text-gray-900 mb-2">{plan?.name}</h2>
                            <p className="text-gray-600 text-sm mb-3">Storage: {plan?.storage_space}</p>
                            <ul className="text-sm text-gray-700 space-y-1">
                                <li><strong>Recruiters:</strong> {plan?.no_of_recruiters}</li>
                                <li><strong>Jobs:</strong> {plan?.no_of_jobs}</li>
                                <li><strong>Resumes:</strong> {plan?.no_of_resumes}</li>
                                <li><strong>Emails:</strong> {plan?.no_of_emails}</li>
                                <li><strong>Email AI usage:</strong> {plan?.email_ai_usage}</li>
                                <li><strong>AI Job Usage:</strong> {plan?.job_ai_usage}</li>
                                <li><strong>Duration:</strong> {plan?.duration.months} Month(s)</li>
                                <li><strong>Created:</strong> {new Date(plan?.created_at).toLocaleDateString()}</li>
                            </ul>
                            <div className="flex" style={{justifyContent:'space-between'}}>
                                <ButtonHallow className="w-auto" content="Edit" onClick={() => handleEditClick(plan)} />
                                {/* <ButtonHallow className="w-auto" style={{border:'1px solid red',color:'red'}} content="delete" onClick={() => handleDeletePlan(plan)} /> */}
                            </div>
                        </div>
                    ))}
                </div>
            </div>
            {isEditing && selectedPlan && (
                <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-[9]">
                    <div className="bg-white p-8 rounded-2xl shadow-xl w-[600px] max-h-[90vh] flex flex-col">
                        <h2 className="text-2xl font-bold text-gray-900 mb-6">Edit Plan - {selectedPlan?.name}</h2>
                        
                        <div className="flex-1 overflow-y-auto max-h-[calc(90vh-72px)] mb-4">
                            <div className="grid grid-cols-2 gap-4">
                            {Object.keys(selectedPlan)
                                .filter((key) => !["created_at", "updated_at", "plans_id","resume_file_size_mb"].includes(key))
                                .map((key) => (
                                key === "overage" ? (
                                    <div key={key}>
                                        <label className="block text-sm font-medium text-gray-700 capitalize">
                                            {key.replace(/_/g, " ")}
                                        </label>
                                        <select
                                            name={key}
                                            value={selectedPlan?.[key]}
                                            onChange={(e) => setSelectedPlan({ ...selectedPlan, [key]: e.target.value === "true" })}
                                            className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg w-full p-3 mt-1"
                                        >
                                            <option value="true">Enabled</option>
                                            <option value="false">Disabled</option>
                                        </select>
                                    </div>
                                ) :
                                key !== "duration" ? (
                                    <div key={key}>
                                        <label className="block text-sm font-medium text-gray-700">
                                            {key.replace(/_/g, " ").replace(/\b\w/g, (char) => char.toUpperCase())}
                                        </label>
                                        <input
                                            type={typeof selectedPlan?.[key] === "number" ? "number" : "text"}
                                            value={key === "storage_space" 
                                                ? selectedPlan?.[key].replace(/\s*GB$/, "")
                                                : selectedPlan?.[key]}
                                            className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg w-full p-3"
                                            onChange={(e) => setSelectedPlan({ ...selectedPlan, [key]: e.target.value })}
                                        />
                                    </div>
                                ) : (
                                    <div key={key}>
                                        <label className="block text-sm font-medium text-gray-700">Duration (Months)</label>
                                        <input
                                            type="number"
                                            value={selectedPlan?.duration?.months}
                                            className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg w-full p-3"
                                            onChange={(e) => setSelectedPlan({
                                                ...selectedPlan,
                                                duration: { months: Number(e.target.value) }
                                            })}
                                        />
                                    </div>
                                )
                            ))}
                        </div>
                        </div>
                        
                        <div className="flex justify-between mt-6">
                            <button
                                onClick={handleSave}
                                className="px-6 py-2 rounded-lg w-1/2 mr-2 bg-blue-500 text-white"
                            >
                                Save
                            </button>
                            <button
                                onClick={() => setIsEditing(false)}
                                className="px-6 py-2 rounded-lg w-1/2 ml-2 border border-gray-400"
                            >
                                Cancel
                            </button>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

export default AdminPricing;
